export enum CreditApplicationSource {
    MORTGAGE_APPLICATION_SOURCE_CREDIT = 1,
    MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING = 2,
    MORTGAGE_APPLICATION_SOURCE_CREDIT_SCORE = 3
}
export enum CreditApplicationSource {
    MORTGAGE_APPLICATION_SOURCE_CREDIT = 1,
    MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING = 2,
    MORTGAGE_APPLICATION_SOURCE_CREDIT_SCORE = 3
}
